import type { CSSProperties } from 'react';
import styles from './cardListSkeleton.module.css';

export interface ICardListSkeletonProps {
  count?: number;
}

/** Placeholder cards shown while the activities/issues lists load — so the page
 *  never shows the "no items" empty state at the same time as loading. */
export function CardListSkeleton({ count = 5 }: ICardListSkeletonProps) {
  return (
    <ul className={styles.list} aria-busy="true" aria-hidden="true">
      {Array.from({ length: count }).map((_, i) => (
        <li key={i} className={styles.card} style={{ ['--wave']: `${i * 0.1}s` } as CSSProperties}>
          <div className={styles.icon} />
          <div className={styles.body}>
            <div className={styles.lineTitle} />
            <div className={styles.lineMeta} />
            <div className={styles.bulb} />
          </div>
          <div className={styles.right}>
            <div className={styles.pill} />
            <div className={styles.pill} />
          </div>
        </li>
      ))}
    </ul>
  );
}
